import { chain } from 'lodash';
import { urlHelper } from 'src/app/helpers';
import { formatInterestDataToIdValuePair } from 'src/app/helpers/service.helper';
import { apiSlice } from 'src/app/redux/api/apiSlice';
import {
  BulkInterestLookupDataType,
  BulkInterestLookupResultType,
  InterestLookupDataType,
  InterestsWithNamesLookup,
} from 'src/app/services/interest/interest.service.type';
import { INTERESTS_WHITELIST } from 'src/configs/system.config';
import { finalUrlsConfig } from 'src/configs/url.config';
import { InterestsTypes } from 'src/enums/interests.enum';

export const interestsSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllInterests: builder.query<InterestsWithNamesLookup, BulkInterestLookupDataType | void>({
      query: (params?: BulkInterestLookupDataType) => ({
        url: finalUrlsConfig().interest.base,
        params: urlHelper.getLookupQuery(params),
      }),

      transformResponse: (data: BulkInterestLookupResultType): InterestsWithNamesLookup => {
        const filteredData = data.rows.filter((row) => INTERESTS_WHITELIST().includes(row.type));
        const groupedInterests = chain(filteredData)
          .groupBy('type')
          .map((value: InterestLookupDataType[], key) => {
            const type = Number(key) as InterestsTypes;
            return {
              interestType: type,
              interests: formatInterestDataToIdValuePair(value, type),
            };
          })
          .value();
        return {
          rows: groupedInterests,
          count: data.rows.length,
        };
      },
      providesTags: [{ type: 'Interests', id: 'LIST' }],
    }),
    // bulkInterestLookup: builder.mutation<InterestsWithNamesLookup, { ids: string[] }>({
    //   query: ({ ids }) => ({
    //     url: `${finalUrlsConfig().interest.base}`,
    //     method: 'POST',
    //     body: {
    //       ids: uniq(ids),
    //     },
    //   }),
    //   transformResponse: (data: BulkInterestLookupResultType): InterestsWithNamesLookup => {
    //     const filteredData = data.rows.filter((row) => INTERESTS_WHITELIST().includes(row.type));
    //     const groupedInterests = chain(filteredData)
    //       .groupBy('type')
    //       .map((value: InterestLookupDataType[], key) => {
    //         const type = Number(key) as InterestsTypes;
    //         return {
    //           interestType: type,
    //           interests: formatInterestDataToIdValuePair(value, type),
    //         };
    //       })
    //       .value();
    //     return {
    //       rows: groupedInterests,
    //       count: data.rows.length,
    //     };
    //   },
    // }),
  }),
});

export const { useLazyGetAllInterestsQuery, useGetAllInterestsQuery } = interestsSlice;
